import React, { useCallback, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getSite } from '../tools/fetcher';

export default function ProductBanner() {
    const { isPending, isError, data } = useQuery({
        queryKey: ['sites'],
        queryFn: getSite,
    });

    const splitDescription = useMemo(
        () => data?.product_banner?.description?.split('|') || [],
        [data],
    );

    const RenderList = useCallback(
        ({ list, image }) => (
            <li className="flex items-start sm:items-center gap-4 max-w-[300px] sm:max-w-full sm:gap-6 text-white leading-[28px] sm:leading-[53px]">
                {image?.imageSrc && (
                    <img src={image.imageSrc} alt={image.imageAlt} />
                )}{' '}
                {list}
            </li>
        ),
        [],
    );

    const lists = useMemo(
        () => data?.product_banner_list?.description?.split('|') || [],
        [data],
    );

    if (isPending) {
        return <span>Loading...</span>;
    }
    if (isError) {
        return <span>Error loading data</span>;
    }

    return (
        <div className="bg-apart-green-50 rounded-[20px] pl-[32px] sm:pl-[60px] pt-[24px] sm:pt-[80px] pb-[102px] sm:pb-[182px] space-y-8 bg-apart-dot">
            <p className="text-[32px] leading-[44px] sm:text-[60px] sm:leading-[68px] font-bold text-white max-w-[457px]">
                {splitDescription.length >= 1 && splitDescription[0]}{' '}
                {splitDescription.length >= 2 && (
                    <>
                        <br />
                        <span className="bg-apart-black-100 rounded-full whitespace-nowrap px-3 md:px-6">
                            {splitDescription.length >= 2 &&
                                splitDescription[1]}
                        </span>{' '}
                    </>
                )}
                <br className={'block sm:hidden'} />
                {splitDescription.length >= 3 && splitDescription[2]}
                {splitDescription.length >= 4 && (
                    <>
                        <br />
                        {splitDescription[3]}
                    </>
                )}
            </p>
            <ul className={'space-y-3 sm:space-y-0'}>
                {lists.map((list, index) => (
                    <RenderList
                        key={index}
                        list={list}
                        image={{
                            imageSrc: data?.product_banner_list?.image_src,
                            imageAlt: data?.product_banner_list?.image_alt,
                        }}
                    />
                ))}
            </ul>
        </div>
    );
}
